export default "__VITE_ASSET__XlJIVvMi__"